<template>
  <loading :active="true" :can-cancel="false" :is-full-page="isFullPage"></loading>
</template>

<script>
  import LoadingIndicator from './LoadingIndicator.ts'
  export default LoadingIndicator
</script>